import { useMutation } from "@tanstack/react-query";
import UserService from "../../../service/UserService";
import DomainSetupConstants from "../../../constants/DomainSetupConstants";

const submitDomainSetup = async ({ userId, setupInfo }) => {
  const response = await UserService.domainSetup(
    userId,
    DomainSetupConstants.DOMAIN_TYPE_PRIMARY,
    setupInfo
  );
  return response;
};

export default function useDomainSetup() {
  const mutation = useMutation({ mutationFn: submitDomainSetup });

  const run = async ({ userId, setupInfo }, options) => {
    try {
      await mutation.mutateAsync({ userId, setupInfo }, options);
    } catch (e) {
      // Error is captured in mutation.isError / mutation.error
    }
  };

  const { isPending, isError, error } = mutation;
  return [run, { isPending, isError, error }];
}
